import {Observable, Subscription} from 'rxjs';

import IConfig      from '../Interfaces/IConfig';
import IConfigStore from '../Interfaces/IConfigStore';

const subscribeToConsumerConfig = (
    consumerConfig$: Observable<IConfig>,
    configStore: IConfigStore
): Subscription =>
    consumerConfig$
        .subscribe(nextOptions => configStore.actions.configure(nextOptions));

export default subscribeToConsumerConfig;